import React from "react";
import { Disclose, Table } from "@optimizely/axiom";
import { AccessDetailsTableRow } from "./AccessDetailsTableRow";
import { AccessDetailsByProductId, AccessDetailsRow } from "../../../../domain/AccessDetails";

export const AccessDetailsTable = ({
    accessDetails,
    onRemove
}: {
    accessDetails: AccessDetailsByProductId;
    onRemove?: ({ accessDetailsRow }: { accessDetailsRow: AccessDetailsRow }) => void;
}) => {
    return (
        <div>
            {Object.keys(accessDetails).map((productId) => {
                const { productName, instanceAccess } = accessDetails[productId];
                const showProjectColumn = productId === process.env.REACT_APP_EXPERIMENTATION_PRODUCT_ID;

                return (
                    <Disclose
                        key={`disclose-header-${productId}`}
                        title={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                }}
                            >
                                <span>{productName}</span>
                            </div>
                        }
                    >
                        <div className="push-triple--left">
                            <Table
                                className=""
                                density="tight"
                                shouldAddHover={false}
                                // eslint-disable-next-line
                                style="rule-no-bottom-border"
                                tableLayoutAlgorithm="auto"
                                key={`table-${productId}`}
                            >
                                <Table.THead key={`table-head-${productId}`}>
                                    <Table.TR>
                                        <Table.TH sorting={{}} width={showProjectColumn ? "30%" : "60%"}>
                                            Instance
                                        </Table.TH>
                                        {showProjectColumn && (
                                            <Table.TH sorting={{}} width="30%">
                                                Project
                                            </Table.TH>
                                        )}
                                        <Table.TH sorting={{}} width={"40%"}>
                                            Role(s)
                                        </Table.TH>
                                    </Table.TR>
                                </Table.THead>
                                <Table.TBody key={`table-body-${productId}`}>
                                    {Object.keys(instanceAccess).flatMap((instanceId) => {
                                        return instanceAccess[instanceId].map((instanceRow, rowIdx) => {
                                            const rowKey = `${productId}-${instanceId}-${instanceRow.groupId}-${rowIdx}`;
                                            return (
                                                <AccessDetailsTableRow
                                                    access={instanceRow}
                                                    showProjectColumn={showProjectColumn}
                                                    key={rowKey}
                                                    onRemove={onRemove}
                                                />
                                            );
                                        });
                                    })}
                                </Table.TBody>
                            </Table>
                        </div>
                    </Disclose>
                );
            })}
        </div>
    );
};

AccessDetailsTable.displayName = "AccessDetailsTable";
